export default __webpack_public_path__ + "static/media/quick_play_bg_pattern_flames.7b041e69.png";